// IMPORT PACKAGE REFERENCES

import PropTypes from 'prop-types';
import React from 'react';

// COMPONENT

const LoadingIndicator = props => (
    <div>
        {props.busy && (
            <div
                style={{
                    top: '50%',
                    left: '50%',
                    textAlign: 'center',
                    color: 'dodgerblue',
                    position: 'absolute',
                    transform: 'translate(-50%, 0)',
                }}
            >
                <i className="fa fa-spinner fa-spin fa-4x fa-fw" />
            </div>
        )}
    </div>
);

// CONFIGURE COMPONENT PROP TYPES

LoadingIndicator.propTypes = {
    busy: PropTypes.bool,
};

// EXPORT COMPONENT

export { LoadingIndicator };
